import Vue from "vue"
import Main from "./main.vue"

let FlydotConstructor = Vue.extend(Main)

let instance
let instances = []
let seed = 1

const Flydot = function (options) {
  options = options || {}
  let id = "flydot_" + seed++

  instance = new FlydotConstructor({
    data: options
  })
  instance.id = id
  instance.$mount()
  document.body.appendChild(instance.$el)
  instances.push(instance)
  return instance
}

export default Flydot
